import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'
import {clsx} from 'clsx'

import styles from './ProjectsSections.module.css'

export function ProjectItemSectionFieldsLoading() {
  return (
    <ul className={clsx(styles.FieldListUl, styles.FieldListInternal)}>
      <li className={clsx(styles.FieldListLi, styles.loading)}>
        <ProjectFieldLoading />
        <ProjectFieldLoading />
        <ProjectFieldLoading />
      </li>
    </ul>
  )
}

function ProjectFieldLoading() {
  return (
    <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8, width: '100%', marginTop: 2}}>
      <IssuesLoadingSkeleton height="md" width="40%" />
      <IssuesLoadingSkeleton height="md" width="60%" />
    </span>
  )
}
